import Point from "./Point";
import m, {Vnode, VnodeDOM} from "mithril";
import {Highlighter} from "../../../model/items/imageItem";
import ImageHighlighter from "../imageHighlighter";

export default class PointComment
{
    private static readonly MODAL_DEFAULT_SIZE = {w: 300, h: 77};
    public readonly highlighter: Highlighter;
    private element?: HTMLElement;

    constructor(
        public readonly imageHighlighter: ImageHighlighter,
        private readonly point: Point,
        private readonly onCloseComment: () => void
    ) {
        this.highlighter = imageHighlighter.highlighter;
    }

    private viewTextarea(): Vnode {
        const questionary = this.highlighter.imageItem.questionary;

        return m('textarea', {
            placeholder: questionary.renderText(questionary.messages.get('whyDidYouMarkThisPlace')),
            oninput: (e: InputEvent) => {
                const comment = (<HTMLInputElement>e.currentTarget).value.trim();
                this.point.comment = comment === '' ? null : comment;
            },
            oncreate: (vnodeDOM: VnodeDOM) => {
                const textarea = <HTMLInputElement>vnodeDOM.dom;
                textarea.value = this.point.comment ? this.point.comment : '';
                textarea.focus();
            },
            onkeydown: (e: KeyboardEvent) => {
                if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    this.highlighter.save();
                    this.onCloseComment();
                }
            },
            onchange: () => {
                this.highlighter.save();
            }
        });
    }

    private viewControls(): Vnode {
        return m('.PointComment-controls', {}, [
            m('span.delete', {
                onclick: (e: MouseEvent) => {
                    this.highlighter.addOrRemovePoint(0, this.point); // remove point
                    this.onCloseComment();
                },
            }, [
                m('i.icon.icon-delete.danger'),
            ]),
            m('span.save', {
                onclick: (e: MouseEvent) => {
                    // Save is in textarea - onchange
                    this.onCloseComment(); // and close
                },
            }, [
                m('i.icon.icon-check-circle.success'),
            ]),
        ]);
    }

    private setDialogPosition(container: HTMLElement|null, dialog: HTMLElement): void {
        const pointInRatio = this.imageHighlighter.pointByElementSize(this.point.x, this.point.y);

        if (!container) {
            dialog.style.left = pointInRatio.x+'px';
            dialog.style.top = pointInRatio.y+'px';
            return;
        }

        const cw = container.offsetWidth;
        const ch = container.offsetHeight;
        const mw = PointComment.MODAL_DEFAULT_SIZE.w;
        const mh = PointComment.MODAL_DEFAULT_SIZE.h;

        // Horizontal
        if (pointInRatio.x + mw > cw) {
            dialog.style.right = '20px';
        } else {
            dialog.style.left = pointInRatio.x+'px';
        }

        // Vertical
        if (pointInRatio.y + mh + 20 > ch) {
            dialog.style.bottom = '20px';
        } else {
            dialog.style.top = pointInRatio.y+'px';
        }
    }

    view(): Vnode {
        return m('.PointComment', {
            onclick: (e: MouseEvent) => {
                e.stopPropagation();
            }
        }, [
            this.viewTextarea(),
            this.viewControls(),
        ]);
    }


    private onResize() {
        if (this.element) {
            this.setDialogPosition(this.element.parentElement, this.element);
        }
    }

    oncreate(vnodeDOM: VnodeDOM) {
        this.element = <HTMLElement>vnodeDOM.dom;
        $(window).resize(this.onResize.bind(this));
        this.onResize();
    }

    onremove() {
        $(window).off('resize', this.onResize.bind(this))
    }


}